export default __webpack_public_path__ + "static/media/badge.c9ed7618.svg";